module.exports = __webpack_public_path__ + "img/img_left_nav_recommend_hover.b514b1b4.svg";